<template>
    <div id="sql" class="mt">
        <a-row type="flex" justify="start">
            <a-col :span="7" style="border-right: 1px solid #efefef;padding-right: 4px;">
               <a-row type="flex" justify="start">
                   <a-col>
                       <a-tooltip placement="topLeft">
                           <template slot="title">
                               <span>{{ $t('generic.Add') }}</span>
                           </template>
                           <img @click="addDataSource" class="sbxs" src="../../../assets/img/ss-add.png" width="22" height="22">
                       </a-tooltip>
                       <a-popconfirm
                               :title="$t('generic.AreyoudeleTask')"
                               @confirm="deldataSource"
                               :okText="$t('generic.Yes')"
                               :cancelText="$t('generic.No')">
                           <a-tooltip placement="topLeft" class="ml4">
                               <template slot="title">
                                   <span>{{ $t('generic.Delete') }}</span>
                               </template>
                               <img class="sbxs" src="../../../assets/img/ss-delete.png" width="22" height="22">
                           </a-tooltip>
                       </a-popconfirm>

                   </a-col>
               </a-row>
                <a-row class="mt4">
                    <vxe-table
                            border
                            resizable
                            class="mytable-style"
                            ref="dataSourceTable"
                            highlight-hover-row
                            :cell-class-name="cellClassName"
                            @cell-click="dbcellClickEvent"
                            size="mini"
                            :data="tableData">
                        <template v-slot:empty>
                            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                        </template>
                        <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="dsName" title="Data Source Name" minWidth="150"></vxe-table-column>
                    </vxe-table>
                </a-row>
            </a-col>
            <a-col :span="16" class="ml4" v-if="tableData.length > 0">
                <a-tabs v-model="activeKey"  @change="changeTabs">
                    <a-tab-pane key="1" tab="SQL">
                        <sql-coms :dataSourceRow="dataSourceRow" :headerUid="headerUid"  v-on:emitSqlcomsVal="getSqlComs"></sql-coms>
                    </a-tab-pane>
                    <a-tab-pane key="2" tab="Column" >
                        <column :headerUid="headerUid" ref="columnComponent" ></column>
                    </a-tab-pane>
                    <a-tab-pane key="3" tab="Condition" >
                        <condition :dataSourceRow="dataSourceRow" ref="conditionComponent"></condition>
                    </a-tab-pane>
                </a-tabs>
            </a-col>
        </a-row>
        <a-modal
            title="Add DataSource"
            :visible="addDataVis"
            width="45%"
            @cancel="() => (addDataVis = !addDataVis)"
        >
            <template slot="footer">
                <a-button type="primary" size="small" @click="addSaveSource">Save</a-button>
            </template>
            <a-form :form="addSourceForm">
                <a-form-item label="Data Source Name" v-bind="formItemLayout">
                    <a-input
                            :placeholder="$t('publicLang.PleaseEnter')"
                            size="small"
                            style="width: 100%;"
                            v-decorator="[
                              'dsName',
                              {
                                rules: [{ required: true, message: $t('publicLang.Required')}]
                              }
                            ]"
                    />
                </a-form-item>
                <a-form-item label="Data Source Type" v-bind="formItemLayout">
                    <a-select
                            allowClear
                            :placeholder="$t('publicLang.PleaseSelect')"
                            style="width: 100%"
                            size="small"
                            v-decorator="[
                              'dsType',
                              {initialValue: 'SQL'}
                            ]"
                    >
                        <a-select-option value="SQL">SQL</a-select-option>
                        <a-select-option value="Procedure">Procedure</a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import column from './DS/column.vue'
    import condition from './DS/condition.vue'
    import sqlComs from './DS/sql.vue'
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        components:{
            column,
            condition,
            sqlComs
        },
        props:{
            headerUid: {
                type: String,
                default: function() {
                    return '';
                }
            },
        },
        data(){
            return{
                activeKey: '1',
                addSourceForm:this.$form.createForm(this),
                addDataVis: false,
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                tableData: [],
                dataSourceRow: {},
                dataSourceUid: ''
            }
        },
        watch:{
            headerUid(v){
                this.dataSourceTable()
            }
        },
        created(){
            this.dataSourceTable()
        },
        methods:{
            changeTabs(){

             
                  if  (this.activeKey == 2 && this.$refs.columnComponent != null ){
                    this.$refs.columnComponent.init();
                  }else if(this.activeKey == 3 && this.$refs.conditionComponent != null ){
                         this.$refs.conditionComponent.init();
                  }
            },
          
//            datasource table 相关 add 获取data 数据
            addDataSource(){
                this.addDataVis = true
                this.addSourceForm.resetFields();
            },
            addSaveSource(){
                this.addSourceForm.validateFields((error, values)=>{
                    if(!error){
                        let params = values
                        params.rtMasterUid = this.headerUid
                        ajax.post(api.REPORTGENERICCONFIGDATASOURCE,params).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.dataSourceTable()
                                this.addDataVis = false
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                })
            },
            dataSourceTable(){
                ajax.get(api.REPORTGENERICCONFIGDATASOURCE,{"rtMasterUid": this.headerUid}).then(res=>{
                    if(res.code == 200){
                        this.tableData = res.data
                        if(this.tableData.length > 0){
                            this.dataSourceRow = this.tableData[0]
                            this.dataSourceUid = this.tableData[0].uid
                        }
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            deldataSource(){
                let arr = this.$refs.dataSourceTable.getCheckboxRecords()
                if(arr.length > 0){
                    let params = {uids: []}
                    for(let i in arr){params.uids.push(arr[i].uid)}
                    ajax.post(api.REPORTGENERICDELDATASOURCE,params).then(res=>{
                        if(res.code == 200){
                            this.dataSourceTable()
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'))
                }
            },
            //            双击当前行变色
            cellClassName({ row }) {
                if (row ===  this.dataSourceRow ) {
                    return "col-orange";
                }
            },
            dbcellClickEvent({ row }){
                this.dataSourceRow = row
                this.dataSourceUid = row.uid
            },
            getSqlComs(row){
                this.dataSourceRow.dsName = row
            }
        }
    }
</script>
<style>
    .mytable-style .vxe-body--column.col-orange {
        background-color: #8fbc8f;
        color: #fff;
    }
</style>